import React from 'react';
export function Features() {
  const features = [{
    id: '01',
    title: 'CAMPAIGN AUTOMATION',
    metric: '847',
    label: 'CAMPAIGNS LAUNCHED',
    desc: 'Automated deployment across all major ad networks. No manual errors.'
  }, {
    id: '02',
    title: 'PERFORMANCE TRACKING',
    metric: '99.7%',
    label: 'SYSTEM UPTIME',
    desc: 'Real-time data ingestion. We know what works before you do.'
  }, {
    id: '03',
    title: 'BUDGET OPTIMIZATION',
    metric: '23%',
    label: 'AVG COST REDUCTION',
    desc: 'Algorithmic allocation of funds to high-performing assets only.'
  }, {
    id: '04',
    title: 'CREATIVE TESTING',
    metric: '12k+',
    label: 'VARIANTS TESTED',
    desc: 'Brute-force testing of headlines, images, and copy combinations.'
  }];
  return <section className="border-b-2 border-black" data-id="element-12">
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4" data-id="element-13">
        {features.map((feature, index) => <div key={feature.id} className={`
              p-8 border-black flex flex-col justify-between h-full min-h-[300px]
              ${index !== features.length - 1 ? 'border-b-2 md:border-b-0 md:border-r-2' : ''}
              hover:bg-black hover:text-white transition-colors duration-0 group
            `} data-id="element-14">
            <div data-id="element-15">
              <span className="text-sm font-bold border border-black px-2 py-1 mb-6 inline-block group-hover:border-white group-hover:text-white" data-id="element-16">
                {feature.id}
              </span>
              <h3 className="text-xl font-bold mb-2" data-id="element-17">{feature.title}</h3>
              <p className="text-sm opacity-70 mb-8 group-hover:opacity-90" data-id="element-18">
                {feature.desc}
              </p>
            </div>

            <div className="mt-auto pt-8 border-t border-black border-dashed group-hover:border-white/50" data-id="element-19">
              <div className="text-4xl font-bold text-[#ff0000] mb-1 group-hover:text-[#ff0000]" data-id="element-20">
                {feature.metric}
              </div>
              <div className="text-xs uppercase tracking-wider font-bold" data-id="element-21">
                {feature.label}
              </div>
            </div>
          </div>)}
      </div>
    </section>;
}